// keeping countries like this so I don't need a transform but they could be easily translated later
// also note I'm not using a lookup object as then I'd lose order (which I want to keep)
export const countries = [
  { value: 208, text: 'Denmark',},
  { value: 246, text: 'Finland',},
  { value: 250, text: 'France',},
  { value: 276, text: 'Germany',},
  { value: 300, text: 'Greece',},
  { value: 380, text: 'Italy',},
  { value: 528, text: 'Netherlands',},
  { value: 578, text: 'Norway',},
  { value: 620, text: 'Portugal',},
  { value: 724, text: 'Spain',},
  { value: 752, text: 'Sweden',},
  { value: 756, text: 'Switzerland',},
  { value: 826, text: 'United Kingdom',},
  { value: 840, text: 'United States of America',},
  { value: 4, text: 'Afghanistan',},
  { value: 8, text: 'Albania',},
  { value: 10, text: 'Antarctica',},
  { value: 12, text: 'Algeria',},
  { value: 16, text: 'American Territory',},
  { value: 20, text: 'Andorra',},
  { value: 24, text: 'Angola',},
  { value: 28, text: 'Antigua and Barbuda',},
  { value: 31, text: 'Azerbaijan',},
  { value: 32, text: 'Argentina',},
  { value: 36, text: 'Australia',},
  { value: 40, text: 'Austria',},
  { value: 44, text: 'Bahamas',},
  { value: 48, text: 'Bahrain',},
  { value: 50, text: 'Bangladesh',},
  { value: 51, text: 'Armenia',},
  { value: 52, text: 'Barbados',},
  { value: 56, text: 'Belgium',},
  { value: 60, text: 'Bermuda',},
  { value: 64, text: 'Bhutan',},
  { value: 68, text: 'Bolivia',},
  { value: 70, text: 'Bosnia and Herzegovina',},
  { value: 72, text: 'Botswana',},
  { value: 74, text: 'Bouvet Island',},
  { value: 76, text: 'Brazil',},
  { value: 84, text: 'Belize',},
  { value: 86, text: 'British India',},
  { value: 90, text: 'Solomon Islands',},
  { value: 92, text: 'British Virgin Islands',},
  { value: 96, text: 'Brunei',},
  { value: 100, text: 'Bulgaria',},
  { value: 104, text: 'Burma',},
  { value: 108, text: 'Burundi',},
  { value: 112, text: 'Belarus',},
  { value: 116, text: 'Cambodia',},
  { value: 120, text: 'Cameroon',},
  { value: 124, text: 'Canada',},
  { value: 132, text: 'Cape Verde',},
  { value: 136, text: 'Cayman Islands',},
  { value: 140, text: 'Central African Republic',},
  { value: 144, text: 'Democratic Socialist Republic of Sri Lanka',},
  { value: 148, text: 'Chad',},
  { value: 152, text: 'Chile',},
  { value: 156, text: 'China',},
  { value: 158, text: 'China/Taiwan',},
  { value: 162, text: 'Christmas Island Territory',},
  { value: 166, text: 'Cocos (Keeling) Islands',},
  { value: 170, text: 'Colombia',},
  { value: 174, text: 'Comoros',},
  { value: 175, text: 'Departmental Collectivity of Mayotte',},
  { value: 178, text: 'Republic of the Congo',},
  { value: 180, text: 'Democratic Republic of the Congo',},
  { value: 184, text: 'Cook Islands',},
  { value: 188, text: 'Costa Rica',},
  { value: 191, text: 'Croatia',},
  { value: 192, text: 'Cuba',},
  { value: 196, text: 'Cyprus',},
  { value: 203, text: 'Czech Republic',},
  { value: 204, text: 'Benin',},
  { value: 212, text: 'Dominica',},
  { value: 214, text: 'Dominican Republic',},
  { value: 218, text: 'Ecuador',},
  { value: 222, text: 'El Salvador',},
  { value: 226, text: 'Equatorial Guinea',},
  { value: 231, text: 'Ethiopia',},
  { value: 232, text: 'Eritrea',},
  { value: 233, text: 'Estonia',},
  { value: 234, text: 'Faeroe Islands',},
  { value: 238, text: 'Falkland Islands',},
  { value: 239, text: 'South Georgia and the South Sandwich Islands',},
  { value: 242, text: 'Fiji',},
  { value: 248, text: 'Åland Islands',},
  { value: 254, text: 'French Guiana',},
  { value: 258, text: 'French Polynesia',},
  { value: 260, text: 'French Southern and Antarctic Lands',},
  { value: 262, text: 'Djibouti',},
  { value: 266, text: 'Gabonese',},
  { value: 268, text: 'Georgia',},
  { value: 270, text: 'Gambia',},
  { value: 275, text: 'Palestina',},
  { value: 288, text: 'Ghana',},
  { value: 292, text: 'Gibraltar',},
  { value: 296, text: 'Kiribati',},
  { value: 304, text: 'Greenland',},
  { value: 308, text: 'Grenada',},
  { value: 312, text: 'Guadeloupe',},
  { value: 316, text: 'Guam',},
  { value: 320, text: 'Guatemala',},
  { value: 324, text: 'Guinea',},
  { value: 328, text: 'Guyana',},
  { value: 332, text: 'Haiti',},
  { value: 334, text: 'Heard Island and McDonald Islands',},
  { value: 336, text: 'Holy See/ Vatican City State',},
  { value: 340, text: 'Honduras',},
  { value: 344, text: 'Hong Kong',},
  { value: 348, text: 'Hungary',},
  { value: 352, text: 'Iceland',},
  { value: 356, text: 'India',},
  { value: 360, text: 'Indonesia',},
  { value: 364, text: 'Iran',},
  { value: 368, text: 'Iraq',},
  { value: 372, text: 'Ireland',},
  { value: 376, text: 'Israel',},
  { value: 384, text: 'Côte d’Ivoire',},
  { value: 388, text: 'Jamaica',},
  { value: 392, text: 'Japan',},
  { value: 398, text: 'Kazakhstan',},
  { value: 400, text: 'Jordan',},
  { value: 404, text: 'Kenya',},
  { value: 408, text: 'Korea, North',},
  { value: 410, text: 'Korea, South',},
  { value: 414, text: 'Kuwait',},
  { value: 417, text: 'Kyrgyz',},
  { value: 418, text: 'Laos',},
  { value: 422, text: 'Lebanon',},
  { value: 426, text: 'Lesotho',},
  { value: 428, text: 'Latvia',},
  { value: 430, text: 'Liberia',},
  { value: 434, text: 'Libya',},
  { value: 438, text: 'Liechtenstein',},
  { value: 440, text: 'Lithuania',},
  { value: 442, text: 'Luxembourg',},
  { value: 446, text: 'Macao',},
  { value: 450, text: 'Madagascar',},
  { value: 454, text: 'Malawi',},
  { value: 458, text: 'Malaysia',},
  { value: 462, text: 'Maldives',},
  { value: 466, text: 'Mali',},
  { value: 470, text: 'Malta',},
  { value: 474, text: 'Martinique',},
  { value: 478, text: 'Mauritania',},
  { value: 480, text: 'Mauritius',},
  { value: 484, text: 'Mexico',},
  { value: 492, text: 'Monaco',},
  { value: 496, text: 'Mongolia',},
  { value: 498, text: 'Moldova',},
  { value: 499, text: 'Montenegro',},
  { value: 500, text: 'Montserrat',},
  { value: 504, text: 'Morocco',},
  { value: 508, text: 'Mozambique',},
  { value: 512, text: 'Oman',},
  { value: 516, text: 'Namibia',},
  { value: 520, text: 'Nauru',},
  { value: 524, text: 'Nepal',},
  { value: 531, text: 'Curaçao',},
  { value: 533, text: 'Aruba',},
  { value: 534, text: 'Sint Maarten',},
  { value: 535, text: 'Caribbean Netherlands',},
  { value: 540, text: 'New Caledonia',},
  { value: 548, text: 'Vanuatu',},
  { value: 554, text: 'New Zealand',},
  { value: 558, text: 'Nicaragua',},
  { value: 562, text: 'Niger',},
  { value: 566, text: 'Nigeria',},
  { value: 570, text: 'Niue',},
  { value: 574, text: 'Norfolk Island',},
  { value: 580, text: 'Mariana Islands',},
  { value: 581, text: 'Minor Outlying Islands',},
  { value: 583, text: 'Micronesia',},
  { value: 584, text: 'Marshall Islands',},
  { value: 585, text: 'Palau',},
  { value: 586, text: 'Pakistan',},
  { value: 591, text: 'Panama',},
  { value: 598, text: 'Papua New Guinea',},
  { value: 600, text: 'Paraguay',},
  { value: 604, text: 'Peru',},
  { value: 608, text: 'Philippines',},
  { value: 612, text: 'Pitcairn Islands',},
  { value: 616, text: 'Poland',},
  { value: 624, text: 'Guinea-Bissau',},
  { value: 626, text: 'East Timor',},
  { value: 630, text: 'Puerto Rico',},
  { value: 634, text: 'Qatar',},
  { value: 638, text: 'Réunion',},
  { value: 642, text: 'Romania',},
  { value: 643, text: 'Russian Federation',},
  { value: 646, text: 'Rwanda',},
  { value: 652, text: 'Saint Barthélemy',},
  { value: 654, text: 'Saint Helena',},
  { value: 659, text: 'Saint Kitts and Nevis',},
  { value: 660, text: 'Anguilla',},
  { value: 662, text: 'Saint Lucia',},
  { value: 663, text: 'Saint Martin',},
  { value: 666, text: 'Saint Pierre and Miquelon',},
  { value: 670, text: 'Saint Vincent and the Grenadines',},
  { value: 674, text: 'San Marino',},
  { value: 678, text: 'São Tomé and Príncipe',},
  { value: 682, text: 'Saudi Arabia',},
  { value: 686, text: 'Senegal',},
  { value: 688, text: 'Serbia',},
  { value: 690, text: 'Seychelles',},
  { value: 694, text: 'Sierra Leone',},
  { value: 702, text: 'Singapore',},
  { value: 703, text: 'Slovakia',},
  { value: 704, text: 'Vietnam',},
  { value: 705, text: 'Slovenia',},
  { value: 706, text: 'Somali Republic',},
  { value: 710, text: 'South Africa',},
  { value: 716, text: 'Zimbabwe',},
  { value: 728, text: 'South Sudan',},
  { value: 729, text: 'Sudan',},
  { value: 732, text: 'Western Sahara',},
  { value: 740, text: 'Suriname',},
  { value: 744, text: 'Svalbard and Jan Mayen',},
  { value: 748, text: 'Swaziland',},
  { value: 760, text: 'Syria',},
  { value: 762, text: 'Tajikistan',},
  { value: 764, text: 'Thailand',},
  { value: 768, text: 'Togo',},
  { value: 772, text: 'Tokelau',},
  { value: 776, text: 'Tonga',},
  { value: 780, text: 'Trinidad and Tobago',},
  { value: 784, text: 'United Arab Emirates',},
  { value: 788, text: 'Tunisia',},
  { value: 792, text: 'Turkey',},
  { value: 795, text: 'Turkmenistan',},
  { value: 796, text: 'Turks and Caicos Islands',},
  { value: 798, text: 'Tuvalu',},
  { value: 800, text: 'Uganda',},
  { value: 804, text: 'Ukraine',},
  { value: 807, text: 'Macedonia',},
  { value: 818, text: 'Egypt',},
  { value: 831, text: 'Bailiwick of Guernsey',},
  { value: 832, text: 'Bailiwick of Jersey',},
  { value: 833, text: 'Isle of Man',},
  { value: 834, text: 'Tanzania',},
  { value: 850, text: 'Virgin Islands',},
  { value: 854, text: 'Burkina Faso',},
  { value: 858, text: 'Uruguay',},
  { value: 860, text: 'Uzbekistan',},
  { value: 862, text: 'Venezuela',},
  { value: 876, text: 'Wallis and Futuna',},
  { value: 882, text: 'Samoa',},
  { value: 887, text: 'Yemen',},
  { value: 894, text: 'Zambia',},
];
